/**
 * Directive to use with checkboxes to compose a string as a kind of enumerator list.
 * @author Tom Verschoore de la Houssaije
 * @see https://github.com/amaanm/ng2-checklist/blob/master/src/checklist.ts
 */
import { ElementRef, EventEmitter } from '@angular/core';
/**
 * Directive to use with checkboxes to compose a string as a kind of enumerator list.
 */
var ChecklistDirective = /** @class */ (function () {
    /**
     * Constructs a ChecklistDirective.
     * @param element Reference to HTML element.
     */
    function ChecklistDirective(element) {
        this.element = element;
        /** The value containing the composed enumerator string */
        this.symChecklist = '';
        /** Event to notify when the value has changed. */
        this.symChecklistChange = new EventEmitter();
    }
    /**
     * Listens to changes whether a checkbox is checked or not,
     * constructs a new value accordingly and emit a checklist changed evet.
     * @param $event HTML event.
     */
    ChecklistDirective.prototype.onChange = function ($event) {
        if (this.symChecklist == null) {
            this.symChecklist = '';
        }
        // Split the items into an array
        var checkItems = this.symChecklist.split(' ');
        // clean up input
        checkItems = checkItems.filter(function (item) { return item !== ''; });
        // add or delete from selection?
        if ($event.target.checked) {
            // items is checked, so add to items
            if (checkItems.indexOf($event.target.value) === -1) {
                // if it does not exist
                checkItems.push($event.target.value);
            }
        }
        else {
            // items is not checked, remove from check items
            checkItems = checkItems.filter(function (item) { return item !== $event.target.value; });
        }
        // Join the results because backend expect this input for checkboxes
        this.symChecklist = checkItems.join(' ');
        // Fire an event
        this.symChecklistChange.emit(this.symChecklist);
    };
    Object.defineProperty(ChecklistDirective.prototype, "isChecked", {
        /**
         * Gets a boolean flag indicated whether or not the associated checkbox should be checked or not according the checklist.
         */
        get: function () {
            if (this.symChecklist == null) {
                return false;
            }
            return this.symChecklist.indexOf(this.element.nativeElement.value) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    return ChecklistDirective;
}());
export { ChecklistDirective };
